<div class="dialog-container">
    <p style="margin-top: 16px">{{ uploadLabel | i18next }}</p>

    <div class="file-upload">
        <aumico-file-upload
            [tint]="true"
            [accept]="acceptedFileTypes"
            [extensionErrorKey]="fileTypeErrorKey"
            (fileChange)="onFileUploadedChanged($event)"
        >
        </aumico-file-upload>
        <div class="action-wrapper">
            <button (click)="closeDialog()">
                {{ 'aumico_users_organization_change_organization_state_modal_confirm_no_action' | i18next }}
            </button>
            <button class="confirmation-button" (click)="applyActionAndClose()" [disabled]="uploadedFile == null">
                {{ 'aumico_users_organization_change_organization_state_modal_confirm_action' | i18next }}
            </button>
        </div>
    </div>
</div>
